import { useEffect, useMemo, useState, MouseEventHandler } from 'react';
import L from 'leaflet';
import { useStore } from '@ui/hooks/useStore';
import { IStoredDevice } from '@store/Devices.store';
import { position } from '@store/Map.store';

interface IState {
    lastBounds: L.LatLngBounds | null;
}

const useMap = () => {
    const { devices, map, lang, sidebar, groups, telemetry, user, app } =
        useStore();

    const initState: IState = {
        lastBounds: null,
    };
    const [state, setState] = useState(initState);

    const coordsList = useMemo(() => {
        return app.page !== 'history' && app.page !== 'support'
            ? map.lastCoordsList
            : map.historyCoordsList;
    }, [app.page, map.lastCoordsList, map.historyCoordsList]);

    const handleMapDrag = (currentPosition: position) => {
        map.setCurrentPosition(currentPosition);
        map.resetPosition();
    };
    const handleMapZoom = (zoom: number, position: position) => {
        map.setCurrentPosition(position);
        map.setZoom(zoom);
        map.resetPosition();
    };
    const handleSideBarBtnClick: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        sidebar.toggleSideBar();
    };
    const handleMapMove = () => {
        map.resetPosition();
    };
    const handleReload = () => {
        map.resetReload();
    };
    const handleDeviceTelemetryOpen: MouseEventHandler<HTMLButtonElement> = (
        e,
    ) => {
        e.preventDefault();
        e.stopPropagation();
        telemetry.toggleTelemetryVisible();
    };
    const handlers = {
        handleMapDrag,
        handleMapZoom,
        handleSideBarBtnClick,
        handleReload,
        handleMapMove,
        handleDeviceTelemetryOpen,
    };

    useEffect(() => {
        return () => {
            const [lat, lon] = map.currentPosition;
            map.setPosition({ lat, lon });
        };
    }, []);
    useEffect(() => {
        const getBoundsArr = (devices: IStoredDevice[]): [number, number][] => {
            let result: [number, number][] = [];
            devices.forEach(({ gpsCoord, lbsCoord }: IStoredDevice) => {
                let res: [number, number] | void;

                if (gpsCoord?.lat && gpsCoord?.lon) {
                    res = [gpsCoord.lat, gpsCoord.lon];
                } else if (lbsCoord?.lat && lbsCoord?.lon) {
                    res = [lbsCoord?.lat, lbsCoord?.lon];
                }
                if (res) result.push(res);
            });      
            return result;
        };
        const lastLatLng = getBoundsArr(map.lastCoordsList);

        const lastBounds = lastLatLng.length
            ? new L.LatLngBounds(lastLatLng)
            : null;
            if (lastBounds && map.isBounds) {
            map.resetBounds();
            setState((prev) => ({ ...prev, lastBounds }));
        } else setState((prev) => ({ ...prev, lastBounds: null }));
    }, [map.isBounds, map.lastCoordsList]);

    return {
        state,
        groups,
        devices,
        app,
        telemetry,
        map,
        sidebar,
        lang,
        user,
        coordsList,
        handlers,
    };
};

export default useMap;
